export default __webpack_public_path__ + "static/media/ico-termos-de-uso.8c06323e.svg";